import React, { useEffect, useState } from "react";
import Sidebaar from "../Component/Sidebar";
import TitleComp from "../Component/TitleComp";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import { Box } from "@mui/material";

import { Button, Col, Form, FormGroup, Modal } from "react-bootstrap";
import { Base_Url } from "../BaseUrl";
import { Bars } from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";
import { compressImage } from "../Component/CompressImage";

function Categories() {
  let token = localStorage.getItem("token");
  const [categories, setCategories] = useState([]);
  const [name, setname] = useState("");
  const [file, setfile] = useState(null);
  const [idindex, setidindex] = useState("");
  const [editimg, seteditimg] = useState("");
  const [loading, setloading] = useState(false);
  const [imageurl, setimageurl] = useState("")


  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (e, value) => {
    setShow(true)
    setimageurl(value)
  };

  const headers = {
    Authorization: `Bearer ${token}`,
  };
  // const handlesubmit = (e) => {
  //   setloading(true);
  //   e.preventDefault();
  //   let formdata = new FormData();

  //   formdata.append("name", name);
  //   if (file) {
  //     formdata.append("image", file);
  //   }
  //   if (idindex) {
  //     formdata.append("_id", idindex);
  //     axios.put(`${Base_Url}/categories`, formdata, { headers }).then((res) => {
  //       // console.log(res);
  //       if (res.data !== null) {
  //         setloading(false);
  //         catgoryget();
  //       }
  //     });
  //   } else {
  //     axios
  //       .post(`${Base_Url}/categories`, formdata, { headers })
  //       .then((res) => {

  //         if (res.data !== null) {
  //           setloading(false);
  //           catgoryget();
  //         }
  //       });
  //   }
  // };


  const handlesubmit = (e) => {
    setloading(true);
    e.preventDefault();
    let formdata = new FormData();
  
    formdata.append("name", name);
    if (file) {
      compressImage(file).then((compressedFile) => {
        
        formdata.append("image", compressedFile);
        if (idindex) {
          formdata.append("_id", idindex);
          axios.put(`${Base_Url}/categories`, formdata, { headers }).then((res) => {
            if (res.data !== null) {
              setloading(false);
              catgoryget();
            }
          });
        } else {
          axios.post(`${Base_Url}/categories`, formdata, { headers }).then((res) => {
            if (res.data !== null) {
              setloading(false);
              catgoryget();
            }
          });
        }
      });
    }
  };
  

  const handleFile = (e) => {
    const selectedfile = e.target.files[[0]];
    // console.log(selectedfile);
    setfile(selectedfile);
  };

  const catgoryget = () => {
    setloading(true);
    axios.get(`${Base_Url}/categories`, { headers }).then((res) => {
      setCategories(res.data.data);
      if (res.data != null) {
        setloading(false);
      }
    });
  };
  useEffect(() => {
    catgoryget();
  }, []);

  const handleedit = (e, id) => {
    e.preventDefault();
    setidindex(categories[id]._id);
    seteditimg(categories[id].image);

    setname(categories[id].name);
  };

  const getRowId = (row) => row._id;
  const columns = [
    { field: "name", headerName: "Name", flex: 1 },

    {
      field: "image",
      headerName: "image",
      flex: 1,
      renderCell: (params) => {
        const { value } = params;
        return (
          <img
            src={`${Base_Url}/${value}`}
            onClick={(e) => handleShow(e, value)}
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
            }}
            className="img-fluid tableimgmui"
          ></img>
        );
      },
    },

    {
      field: "edit",
      headerName: "Edit",
      flex: 1,
      renderCell: (params) => {
        const index = params.row.index; // Corrected to rowIndex
        return (
          <span
            style={{ cursor: "pointer" }}
            onClick={(e) => handleedit(e, index)}
          >
            <i className="fa-solid fa-pen-to-square"></i>
          </span>
        );
      },
    },

    {
      field: "delete",
      headerName: "Delete",
      flex: 1,
      renderCell: (params) => {
        const index = params.row.index;
        const id = params.row._id; // Corrected to rowIndex
        return (
          <span
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              handleDelete(e, id);

            }}
          >
            <i class="fa-solid fa-trash"></i>
          </span>
        );
      },
    },
  ];






  const notify = (message, type) => {
    // console.log("type", type);
    toast[type](message, {
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };



  const handleDelete = (e, id) => {
    e.preventDefault();

    let requestdata = {
      _id: id,
      deleted_at: Math.floor(Date.now() / 1000),
    };

    axios
      .put(`${Base_Url}/categories`, requestdata, { headers })
      .then((res) => {
        // console.log(res);
        if (res.data.message === "Ok") {
          catgoryget();
          notify("Delete Successfully", "success");
          // console.log("Data", res.data);
        }
      })
      .catch((error) => {
        console.error("Error deleting:", error);
        notify("Error deleting", "error");
      });
  };





  return (
    <>
      {loading && (
        <div className="overlay">
          <Bars
            height="80"
            width="80"
            color="#051322"
            ariaLabel="bars-loading"
            visible={true}
          />
        </div>
      )}
      <Sidebaar
        content={
          <>
            <ToastContainer />
            <TitleComp title={idindex ? "Update Category" : "Add Category"} />
            <Form className="my-5" onSubmit={(e) => handlesubmit(e)}>
              <div className="row">
                <Col md="4">
                  <FormGroup>
                    <label htmlFor="">Name</label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setname(e.target.value)}
                      className="form-control"
                    />
                  </FormGroup>
                </Col>
                {editimg && (
                  <Col md="1">
                    <div className="text-center">
                      <img
                        style={{ height: "100px" }}
                        src={`${Base_Url}/${editimg}`}
                        className="img-fluid rounded-2"
                      />
                    </div>
                  </Col>
                )}
                <Col md="4">
                  <FormGroup>
                    <label htmlFor="">Image</label>
                    <input
                      type="file"
                      onChange={(e) => handleFile(e)}
                      className="form-control"
                    />
                  </FormGroup>
                </Col>
                <Col md="2">
                  <button className="btn mt-4 bg-dark text-white">
                    {idindex ? "Update" : "Submit"}
                  </button>
                </Col>
              </div>
            </Form>
            <Col md="12">
              <Box sx={{ height: 500, width: "100%" }}>
                <DataGrid
                  //   rows={data} // Update this line
                  rows={categories.map((row, index) => ({
                    ...row,
                    index,
                  }))}
                  columns={columns}
                  pageSize={5}
                  getRowId={getRowId}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 10 } },
                  }}
                  pageSizeOptions={[5, 10, 25]}
                />
              </Box>
            </Col>

            <Modal show={show} size="md" onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Image</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <img src={`${Base_Url}/${imageurl}`} alt="" />
              </Modal.Body>
              <Modal.Footer>
                <Button  className="text-write bg-secondary  shadow-none border-0" onClick={handleClose}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>

          </>
        }
      />
    </>
  );
}

export default Categories;






























